import { useTranslation } from 'libs/i18n'
import { Currency } from 'shared/components'
import type { RentalItem } from 'features/rentals/types/rentals.types'

export const useRentalDetails = () => {
	const { t } = useTranslation()

	return (rental: RentalItem) => {
		const period = t('{{ count }} days', { count: rental.duration })

		return {
			name: rental.title || period,
			boothType: rental.booth_type_name?.name ?? '—',
			period,
			price: <Currency price={rental.price} />,
			fee: rental.commission ? `${Number(rental.commission)}%` : '—'
		}
	}
}
